function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.709 9s-.286 6.27-1.27 23.393c-.203 3.52 3.195 10.548-1.08 13.37-4.275 2.821-7.552 1.06-9.954 2.125-9.858 4.37-23.17 10.601-25.734 2.907-3.42-9.405 19.12-11.125 20.3-21.276V9zM52.898 36.359c-10.259 0-9.233 10.857-9.233 10.858",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.97 17.55h17.099M22.303 41.146c2.627 2.342 4.226 8.94 3.371 12.36"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.14 46.009C9.6 48.23 3.791 48.866 2.186 44.053c-3.42-9.405 19.119-11.125 20.299-21.276V2.257h17.739s-.09 1.961-.34 6.684",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.486 10.808h13.301M8.82 34.404c2.626 2.342 4.225 8.94 3.37 12.36"
}));

var SvgSocks = function SvgSocks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSocks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Socks.25394ec5.svg";
export { ForwardRef as ReactComponent };